import React from "react";
import { HiOutlineClipboardCheck as Clipboard } from "react-icons/hi";

const CTAButton = ({ className = "" }: { className: string }): JSX.Element => (
  <a
    href="https://docs.google.com/forms/d/e/1FAIpQLSdzBjTcpizwJVrvlqXkcd_HKwfTciGeHnY0z1k1kKK72amHfw/viewform?usp=sf_link"
    target="_blank"
    rel="noreferrer"
  >
    <p
      className={`flex justify-center items-center font-normal rounded-lg py-1 px-3 my-1 text-md text-slate-600 bg-primary-300 hover:bg-primary-400 hover:text-black ${className}`}
    >
      {`Take our Outreach Survey`}
      <Clipboard className="ml-2 mb-1 h-4 w-4 inline text-slate-600" />
    </p>
  </a>
);

export default CTAButton;
